import { useAnalytics } from "~/components/Analytics";
import { ContentItemGrid } from "~/components/ContentItemGrid";
import {
  ContentItemWithImage,
  ContentItemWithImageProps,
} from "~/components/ContentItemWithImage";
import { ReportEntryEvents } from "~/components/ReportLibraryEntryPage/reportLibraryEntryEvents";
import { Headline } from "~/ui-library";

export type ReportLibraryEntryFeaturedProps = {
  posts: ContentItemWithImageProps[];
  title: string | null | undefined;
};

export const ReportLibraryEntryFeatured: React.FC<
  ReportLibraryEntryFeaturedProps
> = ({ title, posts }) => {
  const [heroPost, ...remainingPosts] = posts;
  const { analyticsEnhancedTrack } = useAnalytics();

  const getLinkOnClick =
    (target: "headline" | "kicker", reportIndex: number, reportName?: string) =>
    () =>
      analyticsEnhancedTrack(ReportEntryEvents.FeaturedReportClicked, {
        reportName,
        reportIndex,
        target,
      });

  return (
    <div className="flex flex-col gap-y-m">
      {!!title && (
        <Headline as="h2" level={3} className="text-gray-900">
          {title}
        </Headline>
      )}

      <ContentItemWithImage
        {...heroPost}
        asHero
        imageSize="grow"
        className="min-w-[368px] justify-center"
        onHeadlineClick={getLinkOnClick("headline", 0, heroPost.headline)}
        onKickerClick={getLinkOnClick("kicker", 0, heroPost.headline)}
      />

      {remainingPosts.length === 1 && (
        <ContentItemWithImage
          {...heroPost}
          asHero
          imageSize="grow"
          className="min-w-[368px] justify-center"
          onHeadlineClick={getLinkOnClick("headline", 0, heroPost.headline)}
          onKickerClick={getLinkOnClick("kicker", 0, heroPost.headline)}
        />
      )}

      {remainingPosts.length > 1 && (
        <ContentItemGrid
          variant={
            remainingPosts.length === 2
              ? "1-column-to-2-column-desktop"
              : "3-item-row"
          }
          gutters={false}
          itemBorder={false}
        >
          {remainingPosts.map((post, idx) => (
            <ContentItemWithImage
              key={`${post.id}--${idx}`}
              {...post}
              imagePosition="top"
              onHeadlineClick={getLinkOnClick(
                "headline",
                idx + 1,
                post.headline
              )}
              onKickerClick={getLinkOnClick("kicker", idx + 1, post.headline)}
            />
          ))}
        </ContentItemGrid>
      )}
    </div>
  );
};
